var map = {
	"./arrow_down.svg": 761,
	"./arrow_down_triangle.svg": 762,
	"./checkmark-thick.svg": 763,
	"./checkmark.svg": 764,
	"./delete_success_female.svg": 765,
	"./delete_success_male.svg": 766,
	"./dnd-icon_drop.svg": 767,
	"./dnd-thumb_female.svg": 768,
	"./dnd-thumb_male.svg": 769,
	"./icon_chat.svg": 353,
	"./icon_email.svg": 354,
	"./icon_friend_add.svg": 231,
	"./icon_friend_add_feedback.svg": 355,
	"./icon_friend_remove.svg": 232,
	"./icon_hot.svg": 356,
	"./icon_hot_active.svg": 233,
	"./icon_hot_bw.svg": 234,
	"./icon_hot_crossed_active.svg": 184,
	"./icon_language.svg": 770,
	"./icon_my_profile_f.svg": 771,
	"./icon_my_profile_m.svg": 772,
	"./icon_notification.svg": 773,
	"./icon_ok_sign.svg": 774,
	"./icon_settings.svg": 775,
	"./icon_sign_out.svg": 776,
	"./icon_wink.svg": 357,
	"./icon_wink_feedback.svg": 777,
	"./icon_x_rounded.svg": 358,
	"./upload-photo-blue.svg": 778,
	"./upload_photo.svg": 779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 760;